document.addEventListener('DOMContentLoaded', function () {
  const mobileMenuTitles = document.querySelectorAll('.mobile-menu-title')
  let lastWidth = window.innerWidth

  function updateMenusForViewport (forceUpdate = false) {
    const currentWidth = window.innerWidth

    // On initial load or when crossing the 750px threshold
    if (forceUpdate || (lastWidth <= 750 && currentWidth > 750) || (lastWidth > 750 && currentWidth <= 750)) {
      if (currentWidth > 750) {
        // Desktop: open all menus
        mobileMenuTitles.forEach(function (title) {
          const ul = title.nextElementSibling
          const caretDown = title.querySelector('.sd-icon-caret-down')
          const caretUp = title.querySelector('.sd-icon-caret-up')

          if (ul && ul.classList.contains('hidden')) {
            ul.classList.remove('hidden')
            if (caretDown) caretDown.classList.add('hidden')
            if (caretUp) caretUp.classList.remove('hidden')
          }
        })
      } else {
        // Mobile: close all menus
        mobileMenuTitles.forEach(function (title) {
          const ul = title.nextElementSibling
          const caretDown = title.querySelector('.sd-icon-caret-down')
          const caretUp = title.querySelector('.sd-icon-caret-up')

          if (ul && !ul.classList.contains('hidden')) {
            ul.classList.add('hidden')
            if (caretDown) caretDown.classList.remove('hidden')
            if (caretUp) caretUp.classList.add('hidden')
          }
        })
      }
    }

    lastWidth = currentWidth
  }

  // Initial setup - force update on load
  updateMenusForViewport(true)

  // Use ResizeObserver for modern viewport detection
  // eslint-disable-next-line no-undef
  const resizeObserver = new ResizeObserver(function (entries) {
    updateMenusForViewport()
  })

  resizeObserver.observe(document.body)

  // Click handlers for mobile only
  mobileMenuTitles.forEach(function (title) {
    title.addEventListener('click', function () {
      if (window.innerWidth <= 750) {
        const ul = this.nextElementSibling
        const caretDown = this.querySelector('.sd-icon-caret-down')
        const caretUp = this.querySelector('.sd-icon-caret-up')

        if (ul.classList.contains('hidden')) {
          ul.classList.remove('hidden')
          caretDown.classList.add('hidden')
          caretUp.classList.remove('hidden')
        } else {
          ul.classList.add('hidden')
          caretDown.classList.remove('hidden')
          caretUp.classList.add('hidden')
        }
      }
    })
  })
})
